export default {
  name: "Employer Labor Condition Statements",
  pageInfo: {
    text: "<b><u>Note:</u></b> Read the employer attestations carefully before signing.  It is the employer’s responsibility to verify the accuracy of the application and to understand all of the attestations in this section.  Applications for Professional Athletes must attest to only conditions 1 – 7.",
    coloring: "grey",
  },
  sections: [
    {
      sectionInfo: {
        text: `(1) The offered wage equals or exceeds the prevailing wage determined 
        pursuant to 20 CFR 656.40 and 656.41, and the wage the employer will pay to 
        the foreign worker to begin work will equal or exceed the prevailing wage that 
        is applicable at the time the foreign worker begins work or from the time the 
        foreign worker is admitted to take up the certified employment. <br/><br/>
        (2) The wage offered is not based on commissions, bonuses, or other incentives, 
        unless the employer guarantees a prevailing wage paid on a weekly, bi-weekly, 
        or monthly basis that equals or exceeds the prevailing wage. <br/><br/>
        (3) The employer has enough funds available to pay the wage or salary offered the foreign worker. <br/><br/>
        (4) The employer will be able to place the foreign worker on the payroll on or 
        before the date of the foreign worker's proposed entrance into the United States. <br/><br/>
        (5) The job opportunity does not involve unlawful discrimination by race, creed, 
        color, national origin, age, sex, religion, handicap, or citizenship.<br/><br/>
        (6) The employer's job opportunity is not: <br/>
        &emsp;(i) Vacant because the former occupant is on strike or locked out in the course of 
        a labor dispute involving a work stoppage; or <br/>
        &emsp;(ii) At issue in a labor dispute involving a work stoppage. <br/><br/>
        (7) The job opportunity's terms, conditions, and occupational environment are not 
        contrary to Federal, state or local law. <br/><br/>
        (8) The job opportunity has been and is clearly open to any U.S. worker. <br/><br/>
        (9) The U.S. workers who applied for the job opportunity were rejected for lawful job-related reasons. <br/><br/>
        (10) The job opportunity is for full-time, permanent employment for an employer other than the foreign worker.`,
        coloring: "grey",
        divider: false,
      },
      fields: [
        {
          isGroup: {
            showIndividualFieldError: true,
            fields: [
              {
                machine_name: "iGroup",
                widget: "text",
                hidden: true,
                disabled: true,
                code: "I.1",
                validate: [
                  {
                    subsetOfSetRequired: "iGroup",
                    message: "This field is required.",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: ["sectionIAgreement"],
                    },
                  },
                ],
              },
              {
                machine_name: "sectionIAgreement",
                widget: "checkbox",
                label: " ",
                code: "1",
                tooltip:
                  "1.	Indicate that you are aware you certify under penalty of perjury your knowledge of and compliance with the applicable Labor Condition Statements above covering the conditions of employment for the job opportunity and foreign worker covered by this application by marking the box “Yes” or “No.”",
                choice: `<b>I certify</b> under penalty of perjury my knowledge of and compliance with the applicable 
                Labor Condition Statements above covering the conditions of employment for the job opportunity 
                and foreign worker covered by this application. 20 CFR 656.10(c). <small style="margin-left: 5px;">*</small>`,
              },
            ],
          },
        },
      ],
    },
  ],
};
